import React, { Component } from "react";
import {
  NormalInput,
  NormalButton,
  NormalSelect,
  NormalCheckbox,
  NormalRadio,
  TableWrapper,
} from "component/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getCommonApi,
  commonUpdateApi,
  commonPatchApi,
} from "redux/actions/common";
import SimpleReactValidator from "simple-react-validator";
import { Toast } from "service/toast";
import "./style.scss";
import { withTranslation } from "react-i18next";

export class PrepaidPopupClass extends Component {
  state = {
    id: null,
    itemdesc: "",
    quantity: 1,
    price: "",
    trans_amt: "",
    deposit: "",
    prepaid_value: "",
    isopen_prepaid: false,
    bonus: "",
    validPeriodList: [],
    validPeriodValue: "",
    memberCardAccess: false,
    periodNameInput: "",
    conInclusiveList: [
      {
        value: "All",
        label: "All",
      },
      {
        value: "Service Only",
        label: "Service Only",
      },
      {
        value: "Product Only",
        label: "Product Only",
      },
    ],
    conInclusiveValue: "",
    conInclusiveList1: [],
    conInclusiveValue1: "",
    exclusiveList: [
      {
        value: "Service Only",
        label: "Service Only",
      },
      {
        value: "Product Only",
        label: "Product Only",
      },
    ],
    exclusiveValue: "",
    exclusiveList1: [],
    exclusiveValue1: "",
    conAllCheckBox: false,

    conAmountValue: 0,
    conAmountRadio: true,
    headerDetails: [
      { label: "", sortKey: false, width: "120px" },
      { label: "Type", sortKey: false, width: "120px" },
      { label: "Condition Type1", sortKey: false, width: "150px" },
      {
        label: "Condition Type2",
        sortKey: false,
        width: "150px",
      },
      {
        label: "Amount",
        width: "100px",
      },
      {
        label: "Rate",
        sortKey: false,
        width: "100px",
      },
    ],
    prepaidCrediInput: 500,
    prepaidCredit: false,
    sellingPriceInput: 500,
    conditionTableList: [],
    inclusiveDropdownDisable: false,
    addBtnDisable: true,
    inclusiveDropdownId: "",
    exclusiveDrpdownId: "",
    backupPrice: "",
    backupDeposit: "",
    backupPrepaidValue: "",
    backupBonus: "",
    prepaidModalVal: {},
  };
  componentWillMount = () => {
    this.validator = new SimpleReactValidator({
      element: (message) => (
        <span className="error-message text-danger validNo fs14">
          {message}
        </span>
      ),
      autoForceUpdate: this,
    });
  };
  componentDidMount = () => {
    console.log("tokenUpdate", JSON.stringify(this.props.tokenDetails));
    this.getPrepaidInfo();
    this.getValidPeriodList();
  };
  handleClear = () => {
    this.setState({
      id: null,
      itemdesc: "",
      quantity: 1,
      price: "",
      trans_amt: "",
      deposit: "",
      prepaid_value: "",
      isopen_prepaid: false,
      bonus: "",
    });
  };

  getPrepaidInfo = () => {
    let {
      id,
      itemdesc,
      quantity,
      price,
      trans_amt,
      deposit,
      prepaid_value,
      isopen_prepaid,
      bonus,
      conditionTableList,
      validPeriodValue,
      memberCardAccess,

      backupPrice,
      backupDeposit,
      backupPrepaidValue,
      backupBonus,
    } = this.state;
    this.props.getCommonApi(`cartprepaid/${this.props.cartId}/`).then((key) => {
      let { status, data } = key;

      if (status == "200") {
        if (data) {
          id = data?.id;
          itemdesc = data?.itemdesc;
          quantity = data?.quantity;
          price = data?.price;
          trans_amt = Number(data?.price - data.deposit);
          deposit = data?.deposit;
          prepaid_value = data?.prepaid_value;
          isopen_prepaid = data?.isopen_prepaid;
          bonus = Number(data?.prepaid_value - data?.price);
          conditionTableList = data?.openprepaid_condition;
          validPeriodValue = data?.prepaid_valid_period;
          memberCardAccess = data?.membercardnoaccess;

          backupPrice = data?.price;
          backupDeposit = data?.deposit;
          backupPrepaidValue = data?.prepaid_value;
          backupBonus = Number(data?.prepaid_value - data?.price);
          this.setState({
            id,
            itemdesc,
            quantity,
            price,
            trans_amt,
            deposit,
            prepaid_value,
            isopen_prepaid,
            bonus,
            conditionTableList,
            validPeriodValue,
            memberCardAccess,
            backupPrice,
            backupDeposit,
            backupPrepaidValue,
            backupBonus,
          });
        }
      }
    });
  };

  handleChange = async ({ target: { value, name } }) => {
    this.setState({
      [name]: value,
    });
  };
  handleApply = async () => {
    let {
      discountFields,
      unit_price_after_discount,
      discount_price_txt,
      is_percentage,
    } = this.state;
    if (Number(discount_price_txt) > 0) {
      if (Number(is_percentage) == 1) {
        if (discountFields.disc_reason && discountFields.disc_reason != "") {
          if (
            Number(discountFields.disc_reason) != 182 ||
            (Number(discountFields.disc_reason) == 182 &&
              discountFields.discreason_txt != "")
          ) {
            discountFields["discount_amt"] = Number(
              (Number(unit_price_after_discount).toFixed(2) / 100) *
                Number(discount_price_txt)
            ).toFixed(2);

            discountFields["discount"] = Number(
              (Number(discountFields["discount_amt"]).toFixed(2) /
                Number(unit_price_after_discount).toFixed(2)) *
                100
            ).toFixed(2);
            await this.setState({ discountFields });
          } else {
            Toast({
              type: "error",
              message: "Please Enter Discount Reason Text",
            });
            return false;
          }
        } else {
          Toast({
            type: "error",
            message: "Please select Discount Reason",
          });
          return false;
        }
      } else if (Number(is_percentage) == 2) {
        if (discountFields.disc_reason && discountFields.disc_reason != "") {
          if (
            Number(discountFields.disc_reason) != 182 ||
            (Number(discountFields.disc_reason) == 182 &&
              discountFields.discreason_txt != "")
          ) {
            discountFields["discount_amt"] =
              Number(discount_price_txt).toFixed(2);
            discountFields["discount"] = null;
            await this.setState({ discountFields });
          } else {
            Toast({
              type: "error",
              message: "Please Enter Discount Reason Text",
            });
            return false;
          }
        } else {
          Toast({
            type: "error",
            message: "Please select Discount Reason",
          });
          return false;
        }
      } else {
        Toast({
          type: "error",
          message: "Please select Discount Type",
        });
        return false;
      }
      let body = {
        discount: Number(discountFields.discount),
        discount_amt: Number(discountFields.discount_amt),
        disc_reason: Number(discountFields.disc_reason),
        discreason_txt: discountFields.discreason_txt,
      };
      this.props
        .commonUpdateApi(
          `itemcart/${this.props.cartId}/?disc_add=1&disc_reset=0`,
          body
        )
        .then((key) => {
          this.handleClear();
          this.getDiscountInfo();
          this.getDiscountReasons();
        });
    } else {
      Toast({
        type: "error",
        message: "Discount should be greater than zero",
      });
      return false;
    }
  };

  handleSubmit = () => {
    let {
      id,
      price,
      prepaid_value,
      deposit,
      itemdesc,
      memberCardAccess,
      validPeriodValue,
      conditionTableList,
    } = this.state;

    // conditonTableLengthCheck
    if (conditionTableList.length === 0) {
      Toast({
        type: "error",
        message: "Conditions table should not be empty",
      });
      return;
    }
    if (Number(prepaid_value) < Number(price)) {
      Toast({
        type: "error",
        message: "Amount should be less than or equal to prepaid value",
      });
      return;
    }
    if (Number(deposit) > Number(price)) {
      Toast({
        type: "error",
        message: "Deposit amount should be less than or equal to price",
      });
      return;
    } else {
      if (this.validator.allValid()) {
        let { id, prepaid_value, deposit } = this.state;
        let payloadData = [...this.state.conditionTableList];
        payloadData.forEach((remObj) => {
          delete remObj["amount"];
          delete remObj["itemcart"];
          delete remObj["checkboxStatus"];
        });

        let body = {
          id: id,
          price: price,
          prepaid_value: prepaid_value,
          deposit: deposit,
          openprepaid_condition: payloadData,
          itemdesc: itemdesc,
          membercardnoaccess: memberCardAccess,
          prepaid_valid_period: validPeriodValue,
        };

        this.props
          .commonPatchApi(`cartprepaid/${this.props.cartId}/`, body)
          .then((key) => {
            let { status } = key;

            if (status == "200") {
              this.props.handleModal();
            }
          });
      } else {
        this.validator.showMessages();
      }
    }
  };

  handleDepositAmountChange = () => {
    let { price, deposit, trans_amt } = this.state;
    trans_amt = Number(price) - Number(deposit);
    this.setState({
      trans_amt,
    });
  };

  handleAmountChange = () => {
    let { price, bonus, prepaid_value, deposit, trans_amt } = this.state;
    bonus = Number(prepaid_value) - Number(price);
    prepaid_value = Number(price) + Number(bonus);
    deposit = price;
    trans_amt = Number(price) - Number(deposit);
    this.setState({
      deposit,
      trans_amt,
      bonus,
    });
  };
  handlePrepaidValueChange = () => {
    let { price, bonus, prepaid_value, deposit, trans_amt } = this.state;
    price = Number(prepaid_value) - Number(bonus);
    deposit = price;
    trans_amt = Number(price) - Number(deposit);
    this.setState({
      price,
      deposit,
      trans_amt,
    });
  };

  // handlePrepaidModal
  handlePrepaidModalClose = () => {
    this.setState({ prepaidModal: false });
  };

  // handlePeriodInput
  handlePeriodInput = (val) => {
    this.setState({ periodNameInput: val });
  };

  // handleChangeDropdownCom
  handleChangeDropdownCom = (
    e,
    apiCall = false,
    type = "",
    dropdownCheck = false
  ) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
    this.setState({ prepaidModalVal: {} });

    if (dropdownCheck) {
      let { conInclusiveList1, exclusiveList1 } = this.state;
      let filterList = type === "inc" ? conInclusiveList1 : exclusiveList1;
      let IncfilterId = filterList.filter((item) => item.value === value);
      if (IncfilterId.length > 0) {
        if (type === "inc") {
          this.setState({ inclusiveDropdownId: IncfilterId[0].id });
        } else {
          this.setState({ exclusiveDrpdownId: IncfilterId[0].id });
        }
      }
    }

    if (value === "All" && type === "inc") {
      this.setState({ conInclusiveList1: [], conInclusiveValue1: "" });
    }
    if (value === "All" && type === "exc") {
      this.setState({ exclusiveList1: [], exclusiveValue1: "" });
    }

    if (apiCall && value !== "All") {
      this.handleDropdownMenus(value, type);
    }
  };

  //handleInclusiveMenu
  getValidPeriodList = () => {
    this.props.getCommonApi(`prepaidvalidperiod/`).then((res) => {
      let peroidMenuList = [];
      for (let key of res.data) {
        peroidMenuList.push({
          value: key.prepaid_valid_days,
          label: key.prepaid_valid_desc,
        });
      }
      this.setState({ validPeriodList: peroidMenuList });
    });
  };

  //handleInclusiveMenu
  handleDropdownMenus = (val, type) => {
    let apiValue =
      val === "Service Only"
        ? "SERVICE"
        : val === "Product Only"
        ? "RETAIL"
        : "All";
    this.props
      .getCommonApi(`catalogitemdept/?Item_Dept=${apiValue}`)
      .then((res) => {
        let menuOption = [];
        for (let key of res.data) {
          menuOption.push({
            value: key.itm_desc,
            label: key.itm_desc,
            code: key.itm_code,
            seq: key.itm_seq,
            id: key.id,
          });
        }

        if (type === "inc") {
          this.setState({
            conInclusiveList1: menuOption,
          });
        } else {
          this.setState({
            exclusiveList1: menuOption,
          });
        }
      });
  };

  // handleChangeInputCom
  handleChangeInputCom = ({ target: { value, name } }) => {
    this.setState({ [name]: value });
  };

  // handleChangeconAllCheckBox\
  handleConAllCheckBoxCom = ({ target: { value, name } }) => {
    if (name === "conAllCheckBox") {
      this.setState({
        inclusiveDropdownDisable: !this.state.inclusiveDropdownDisable,
        conInclusiveList1: [],
      });
      if (!value) {
        let eventbody = {
          target: {
            name: "conInclusiveValue",
            value: this.state.conInclusiveValue,
          },
        };

        this.handleChangeDropdownCom(eventbody, true, "inc");
      }
    }
    this.setState({ [name]: value });
  };

  // handleInclusiveAdd
  handleToAdd = async (type) => {
    if (type === "inc") {
      let inclusiveValidation = this.handleInclusiveValidation();
      if (inclusiveValidation) {
        this.handleToAddCondition(type, "Inclusive");
      }
    } else {
      let exclusiveValidation = this.handleExclusiveValidation();
      if (exclusiveValidation) {
        this.handleToAddCondition(type, "Exclusive");
      }
    }
  };

  handleToAddCondition = async (type, val) => {
    let {
      conditionTableList,
      conInclusiveValue,
      conInclusiveValue1,
      conAmountValue,
      validPeriodValue,
      prepaid_value,
      exclusiveValue,
      exclusiveValue1,
      memberCardAccess,
      id,
      conAllCheckBox,
      inclusiveDropdownId,
      exclusiveDrpdownId,
    } = this.state;

    if (!validPeriodValue) {
      Toast({
        type: "error",
        message: "please select valid period and then try!",
      });
      return false;
    }

    // let findDuplicateData = conditionTableList.filter(
    //   (item) => item.p_itemtype === val
    // );
    // if (findDuplicateData.length >= 1) {
    //   Toast({
    //     type: "error",
    //     message: "Only one inclusive or exclusive lines allowed now",
    //   });
    //   return false;
    // }

    var dropdownObject = {
      itemdept_id: null,
      itembrand_id: null,
    };
    if (conInclusiveValue === "Service Only" && inclusiveDropdownId) {
      dropdownObject.itemdept_id = inclusiveDropdownId;
      dropdownObject.itembrand_id = null;
      this.setState({ inclusiveDropdownId: "" });
    } else if (conInclusiveValue === "Product Only" && inclusiveDropdownId) {
      dropdownObject.itembrand_id = inclusiveDropdownId;
      dropdownObject.itemdept_id = null;
      this.setState({ inclusiveDropdownId: "" });
    } else if (exclusiveValue === "Service Only" && exclusiveDrpdownId) {
      dropdownObject.itemdept_id = exclusiveDrpdownId;
      dropdownObject.itembrand_id = null;
      this.setState({ exclusiveDrpdownId: "" });
    } else if (exclusiveValue === "Product Only" && exclusiveDrpdownId) {
      dropdownObject.itembrand_id = exclusiveDrpdownId;
      dropdownObject.itemdept_id = null;
      this.setState({ exclusiveDrpdownId: "" });
    } else {
      dropdownObject.itembrand_id = null;
      dropdownObject.itemdept_id = null;
    }

    let typecheck = type === "inc";
    let temparray = [];
    let temObj = {
      op_id: null,
      p_itemtype: typecheck ? "Inclusive" : "Exclusive",
      conditiontype1: typecheck ? conInclusiveValue : exclusiveValue,
      conditiontype2: typecheck
        ? conAllCheckBox
          ? "All"
          : conInclusiveValue1
        : exclusiveValue1,
      prepaid_value: typecheck ? conAmountValue : 0,
      prepaid_sell_amt: typecheck ? conAmountValue : 0,
      prepaid_valid_period: validPeriodValue,
      rate: "Amount$",
      amount: typecheck ? conAmountValue : 0,
      membercardnoaccess: memberCardAccess,
      itemcart: id,
      checkboxStatus: false,
      creditvalueshared: false,
      ...dropdownObject,
    };

    console.log("temObj", JSON.stringify(temObj));

    // check duplicate in array list
    let checkDuplicateStatus = await this.handleDuplicateFun(temObj);
    if (checkDuplicateStatus) {
      Toast({
        type: "error",
        message: "Duplicate condition is not allow",
      });
      return false;
    }

    temparray.push(temObj);
    let mergeArray = [...conditionTableList, ...temparray];
    this.setState({ conditionTableList: mergeArray });

    var total_prepaid = 0;
    for (var i = 0; i < mergeArray.length; i++) {
      total_prepaid += Number(mergeArray[i]["prepaid_value"]);
    }
    let bonus = total_prepaid - total_prepaid;
    this.setState({
      prepaid_value: total_prepaid,
      deposit: total_prepaid,
      price: total_prepaid,
      bonus: bonus,
    });
  };

  handleInclusiveValidation = () => {
    let { conInclusiveValue, conInclusiveValue1, conAllCheckBox } = this.state;
    var errorStatus = true;

    if (!conInclusiveValue) {
      let conInclusiveValidation = {};
      conInclusiveValidation.incluseType = true;
      conInclusiveValidation.incluseTypeErr = "*Required";
      this.setState({ prepaidModalVal: conInclusiveValidation });
      errorStatus = false;
    } else if (conInclusiveValue1 === "") {
      if (conInclusiveValue === "All" || conAllCheckBox) {
        errorStatus = true;
      } else {
        let conInclusiveValidation = {};
        conInclusiveValidation.incluseType1 = true;
        conInclusiveValidation.incluseType1Err = "*Required";
        this.setState({ prepaidModalVal: conInclusiveValidation });
        errorStatus = false;
      }
    }
    return errorStatus;
  };

  handleExclusiveValidation = () => {
    let { exclusiveValue, exclusiveValue1 } = this.state;
    var errorStatus = true;
    if (!exclusiveValue) {
      let conExclusiveValidation = {};
      conExclusiveValidation.excluseType = true;
      conExclusiveValidation.excluseTypeErr = "*Required";
      this.setState({ prepaidModalVal: conExclusiveValidation });
      errorStatus = false;
    } else if (!exclusiveValue1) {
      let conExclusiveValidation = {};
      conExclusiveValidation.excluseType1 = true;
      conExclusiveValidation.excluseType1Err = "*Required";
      this.setState({ prepaidModalVal: conExclusiveValidation });
      errorStatus = false;
    }
    return errorStatus;
  };

  handleDuplicateFun = (currentObj) => {
    let { conditiontype1, conditiontype2 } = currentObj;
    let { conditionTableList } = this.state;
    return conditionTableList.some(
      (item) =>
        item.conditiontype1 === conditiontype1 &&
        item.conditiontype2 === conditiontype2
    );
  };

  // handleClearLineRecalcualte
  handleClearLineRecalculate = () => {
    let originalArray = [...this.state.conditionTableList];
    let filterArrayList = originalArray.filter(
      (list) => list.checkboxStatus === true
    );
    // if (this.state.conditionTableList.length === 1) {
    //   let { backupPrice, backupDeposit, backupPrepaidValue, backupBonus } =
    //     this.state;
    //   this.setState({
    //     prepaid_value: backupPrepaidValue,
    //     deposit: backupDeposit,
    //     price: backupPrice,
    //     bonus: backupBonus,
    //   });
    //   return;
    // }

    var total_prepaid = this.state.price;
    for (var i = 0; i < filterArrayList.length; i++) {
      total_prepaid -= Number(filterArrayList[i]["prepaid_value"]);
    }
    let bonus = total_prepaid - total_prepaid;
    this.setState({
      prepaid_value: total_prepaid,
      deposit: total_prepaid,
      price: total_prepaid,
      bonus: bonus,
    });
  };

  // handleToClear
  handleClearAllMethod = () => {
    // let { backupPrice, backupDeposit, backupPrepaidValue, backupBonus } =
    //   this.state;
    this.setState({
      prepaid_value: 0,
      deposit: 0,
      price: 0,
      bonus: 0,
    });

    this.setState({ conditionTableList: [] });
  };
  // handleToClear
  handleClearLastElement = () => {
    let originalArray = [...this.state.conditionTableList];
    this.handleClearLineRecalculate();
    let filterArrayList = originalArray.filter(
      (list) => list.checkboxStatus !== true
    );

    this.setState({ conditionTableList: filterArrayList });
  };

  // handleCheckBoxTable

  handleCheckBoxTable = (checkboxId) => {
    let originalArray = [...this.state.conditionTableList];
    let filterList = originalArray.filter((_, ix) => ix === checkboxId);
    filterList[0].checkboxStatus = !filterList[0].checkboxStatus;
    this.setState({ conditionTableList: originalArray });
  };

  render() {
    let {
      id,
      itemdesc,
      quantity,
      price,
      trans_amt,
      deposit,
      prepaid_value,
      isopen_prepaid,
      bonus,
      validPeriodList,
      validPeriodValue,
      memberCardAccess,
      periodNameInput,
      conInclusiveList,
      conInclusiveValue,
      conAllCheckBox,
      conInclusiveList1,
      conInclusiveValue1,
      conAmountValue,
      conAmountRadio,
      headerDetails,
      conditionTableList,
      exclusiveList,
      exclusiveValue,
      exclusiveList1,
      exclusiveValue1,
      inclusiveDropdownDisable,
      addBtnDisable,
      prepaidModalVal,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid mb-4">
          <div className="row">
            <div className="col-md-9 col-12">
              <h6 className="text-secondary fs-19 fw-500">
                {t("Open")} {t("Prepaid")}
              </h6>
            </div>
            <div className="col-md-2 col-12">
              <NormalButton
                mainbg={false}
                className="col-12 fs-15 submit-btn"
                label="Submit"
                onClick={() => this.handleSubmit()}
              />
            </div>
          </div>

          <div className="row mt-4 mb-3">
            <div className="col-md-4 col-12">
              <label className="text-left text-black common-label-text fs-17 pb-2">
                {t("Name")}
              </label>
              <div className="input-group">
                <NormalInput
                  placeholder="Enter here"
                  value={itemdesc}
                  name="itemdesc"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="col-md-1 col-12">
              <label className="text-left text-black common-label-text fs-17 pb-2">
                Qty
              </label>
              <div className="input-group">
                <NormalInput
                  placeholder="Enter here"
                  value={quantity}
                  name="quantity"
                  onChange={() => {}}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-2 col-12">
              <label className="text-left text-black common-label-text fs-17 pb-2">
                {t("Amount")}
              </label>
              <div className="input-group">
                <NormalInput
                  placeholder="Enter here"
                  value={price}
                  type="number"
                  name="price"
                  onChange={this.handleChange}
                  onBlur={this.handleAmountChange}
                />
              </div>
              {this.validator.message("price", price, "required")}
            </div>
            <div className="col-md-2 col-12">
              <label className="text-left text-black common-label-text fs-17 pb-2">
                Bonus
              </label>
              <div className="input-group">
                <NormalInput
                  placeholder="Enter here"
                  value={bonus}
                  type="number"
                  name="bonus"
                  onChange={this.handleChange}
                  onBlur={this.handleAmountChange}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-2 col-12">
              <label className="text-left text-black common-label-text fs-17 pb-2">
                {t("Value")}
              </label>
              <div className="input-group">
                <NormalInput
                  placeholder="Enter here"
                  value={prepaid_value}
                  type="number"
                  name="prepaid_value"
                  onChange={this.handleChange}
                  onBlur={this.handlePrepaidValueChange}
                  disabled
                />
              </div>
              {this.validator.message(
                "prepaid value",
                prepaid_value,
                "required"
              )}
            </div>
            <div className="col-md-2 col-12 mt-2">
              <label className="text-left text-black common-label-text fs-17 pb-2">
                {t("Deposit")}
              </label>
              <div className="input-group">
                <NormalInput
                  placeholder="Enter here"
                  value={deposit}
                  type="number"
                  name="deposit"
                  onChange={this.handleChange}
                  onBlur={this.handleDepositAmountChange}
                />
              </div>
              {this.validator.message("deposit", deposit, "required")}
            </div>
            <div className="col-md-2 col-12 mt-2">
              <label className="text-left text-black common-label-text fs-17 pb-2">
                {t("Outstanding")}
              </label>
              <div className="input-group">
                <NormalInput
                  placeholder="Enter here"
                  value={trans_amt}
                  type="number"
                  name="trans_amt"
                  onChange={() => {}}
                  disabled
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-lg-3  d-flex align-items-center">
                    <span>{t("Valid Period")} </span>
                  </div>
                  <div className="col-md-8  d-flex">
                    <NormalSelect
                      options={validPeriodList}
                      value={validPeriodValue}
                      name="validPeriodValue"
                      onChange={(e) => this.handleChangeDropdownCom(e)}
                      className="customer-name py-0 selectFontSize"
                    />
                    <span className="ml-2 d-flex align-items-center">
                      {t("Days")}{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 d-flex align-items-center">
                <NormalCheckbox
                  name="memberCardAccess"
                  label="member card"
                  checked={memberCardAccess}
                  value={memberCardAccess}
                  onChange={(e) => this.handleConAllCheckBoxCom(e)}
                />
              </div>
            </div>

            {/* <div className="row my-3">
              <div className="col-md-4 col-lg-6 col-xl-6">
                <div className="row">
                  <div className="col-md-4 col-lg-3 d-flex align-items-center">
                    <span>{t("Period Name")} </span>
                  </div>

                  <div className="col-md-6 col-lg-6 input-group">
                    <NormalInput
                      type="text"
                      value={periodNameInput} //default value 1set for qty
                      onChange={(e) => this.handleChangeInputCom(e)}
                      className="col-12"
                      name={`periodNameInput`}
                    />
                  </div>
                </div>
              </div>
            </div> */}

            <div className="row my-3">
              <div className="col-md-12 conditionTitleBorder">
                <span>{t("Conditions")} </span>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-md-2 d-flex align-items-center">
               
              </div> */}
              <div className="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-3 mb-2">
                <div className="row">
                  <div className="col-md-4 col-lg-4">
                    <span>{t("Inclusive Type")} </span>
                  </div>
                  <div className="col-md-8 col-lg-8">
                    <NormalSelect
                      options={conInclusiveList}
                      value={conInclusiveValue}
                      name="conInclusiveValue"
                      onChange={(e) =>
                        this.handleChangeDropdownCom(e, true, "inc")
                      }
                      className="customer-name py-0 selectFontSize"
                    />
                    <h6 className="text-danger fs-12 m-2">
                      {prepaidModalVal.incluseType &&
                        prepaidModalVal.incluseTypeErr}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
                <NormalCheckbox
                  name="conAllCheckBox"
                  label="All"
                  checked={conAllCheckBox}
                  value={conAllCheckBox}
                  onChange={(e) => this.handleConAllCheckBoxCom(e)}
                />
              </div>
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                <NormalSelect
                  options={conInclusiveList1}
                  value={conInclusiveValue1}
                  name="conInclusiveValue1"
                  onChange={(e) =>
                    this.handleChangeDropdownCom(e, false, "inc", true)
                  }
                  className="customer-name py-0 selectFontSize"
                  disabled={inclusiveDropdownDisable}
                />
                <h6 className="text-danger fs-12 m-2">
                  {prepaidModalVal.incluseType1 &&
                    prepaidModalVal.incluseType1Err}
                </h6>
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-2">
                <NormalInput
                  type="number"
                  value={conAmountValue} //default value 1set for qty
                  onChange={(e) => this.handleChangeInputCom(e)}
                  className="col-12"
                  name={`conAmountValue`}
                />
              </div>

              <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-1">
                <NormalRadio
                  className=""
                  value={conAmountRadio}
                  label={"Amount $"}
                  name="active"
                />
              </div>
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                <NormalButton
                  buttonClass={"detail-button addtocart mx-2"}
                  mainbg={true}
                  className="col-12 px-4 fs-15 "
                  label="Add"
                  onClick={() => this.handleToAdd("inc")}
                  disabled={!isopen_prepaid}
                  //disabled={validPeriodValue}
                />
                {/* <NormalButton
                  buttonClass={"detail-button addtocart "}
                  mainbg={true}
                  className="col-12 px-4 fs-15 "
                  label="Adv"
                  onClick={() => {}}
                  disabled={!validPeriodValue}
                /> */}
              </div>
            </div>

            <div className="row my-3">
              <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4   d-flex align-items-center">
                <div className="row">
                  <div className="col-md-4">
                    <span className="inclusiveTitle">
                      {t("Exclusive Type")}{" "}
                    </span>
                  </div>
                  <div className="col-md-8">
                    <NormalSelect
                      options={exclusiveList}
                      value={exclusiveValue}
                      name="exclusiveValue"
                      onChange={(e) =>
                        this.handleChangeDropdownCom(e, true, "exc")
                      }
                      className="customer-name py-0 selectFontSize"
                    />

                    <h6 className="text-danger fs-12 m-2">
                      {prepaidModalVal.excluseType &&
                        prepaidModalVal.excluseTypeErr}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <NormalSelect
                  options={exclusiveList1}
                  value={exclusiveValue1}
                  name="exclusiveValue1"
                  onChange={(e) =>
                    this.handleChangeDropdownCom(e, false, "exc", true)
                  }
                  className="customer-name py-0 selectFontSize"
                />
                <h6 className="text-danger fs-12 m-2">
                  {prepaidModalVal.excluseType1 &&
                    prepaidModalVal.excluseType1Err}
                </h6>
              </div>
              <div className="col-md-2 d-flex align-items-center">
                <NormalButton
                  buttonClass={"detail-button addtocart mx-2"}
                  mainbg={true}
                  className="col-12 px-4 fs-15 "
                  label="Add"
                  onClick={() => this.handleToAdd("exc")}
                  disabled={!isopen_prepaid}
                  //disabled={!validPeriodValue}
                />
              </div>
            </div>

            <div>
              <TableWrapper
                headerDetails={headerDetails}
                queryHandler={this.handlePagination}
              >
                {conditionTableList.length > 0 ? (
                  conditionTableList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <NormalCheckbox
                            name="checkboxStatus"
                            label=""
                            checked={item.checkboxStatus}
                            value={item.checkboxStatus}
                            onChange={() => this.handleCheckBoxTable(index)}
                            disabled={!isopen_prepaid}
                          />
                        </td>

                        <td>
                          <div className="text-left">{item.p_itemtype}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.conditiontype1}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.conditiontype2}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.prepaid_value}</div>
                        </td>
                        <td>
                          <div className="text-left">{item.rate}</div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <div className="norecordContainer">
                    <h6>No Record Found </h6>
                  </div>
                )}
              </TableWrapper>
              <div className="row my-3">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex align-items-center">
                  <NormalButton
                    buttonClass={"detail-button addtocart mx-2"}
                    mainbg={true}
                    className="col-12 px-4 fs-15 "
                    label="Clear Line"
                    onClick={() => this.handleClearLastElement()}
                    disabled={!isopen_prepaid}
                  />
                  <NormalButton
                    buttonClass={"detail-button addtocart "}
                    mainbg={true}
                    className="col-12 px-4 fs-15 "
                    label="Clear All"
                    onClick={() => this.handleClearAllMethod()}
                    disabled={!isopen_prepaid}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  basicApptDetail: state.appointment.basicApptDetail,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonUpdateApi,
      commonPatchApi,
    },
    dispatch
  );
};
export const PrepaidPopup = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PrepaidPopupClass)
);
